import React from 'react';
import classes from './FormattedPassage.module.css';

const FormattedPassage = ({ text = '', images = [], boldTextDetector = (text) => text, newImageLoading = false }) => {
  if (!text) {
    return <div>No passage content available</div>;
  }

  const splitText = text.trim().split('\n');

  if (splitText.length === 0) {
    return <div>No passage content available</div>;
  }

  const title = splitText[0];
  const paragraphs = splitText.length > 1 ? splitText.slice(1) : [];

  return (
    <div className={classes["passage-container"]}>
      <h2 className={classes["passage-title"]}>{boldTextDetector(title)}</h2>
      {images?.[0] && (
        <div
          className={`${classes["passage-image-container"]} ${newImageLoading ? classes["loading"] : ""
            }`}
        >
          {newImageLoading && (
            <div className={classes["spinner-wrapper"]}>
              <div className={classes["spinner"]}></div>
            </div>
          )}
          <img
            src={`${images[0]}`}
            alt="Passage illustration"
            className={classes["passage-image"]}
          />
        </div>
      )}
      <div className={classes["passage-content"]}>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{boldTextDetector(paragraph)}</p>
        ))}
      </div>
    </div>
  );
}


export default FormattedPassage;
